import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const ExpertInterviews = () => {
  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Expert Interviews</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Expert Interviews
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['ExpertInterviews', 'Proper', 'COVID']}
              currentClassName="active">
              <li><a href="#ExpertInterviews">Expert Interviews </a></li>
            </Scrollspy>

          </div>

        </div>
        <div className="main_lab_style">
          <section id="ExpertInterviews">

            <h1>
              Expert Interviews
            </h1>

            <div style={{ display: 'flex' }}>
              <div style={{ width: '30%', paddingRight: 20, paddingTop: 30 }}>

                <img style={{ width: '100%', height: 'auto', objectFit: 'initial' }} src="https://i.postimg.cc/3x66mSjx/image.png" alt="" />
                <div>
                  <h3 style={{ margin: 0 }}>
                    Dr Jemma Arakelyan, MD
                  </h3>
                  <em>
                    Yerevan State Medical University (M.D.)
                    Harvard Medical School (HICR scholar)
                  </em>
                </div>
              </div>
              <div style={{ width: '70%' }}>
                <p>
                  Our team arranged an interview with an expert, <strong>Dr Jemma Arakelyan</strong>, <u>an oncologist who has been practising for eight years, to learn more about the disease our project aims to tackle</u>. The interview began with Dr Arakelyan expressing her passion for the field of oncology and what inspired her to divulge into what is often perceived as a tense field. She mentioned how the field bridges humanity and science and her interest in oncology research for cancer drug discovery.
                </p>
              </div>
            </div>
            <br />
            <p>We then discussed common anticancer treatments and the elements that need to be considered due to the subjectivity of each patient's case. She explained how the type of cancer, stage and severity need to be considered to appropriately initiate a treatment plan for the patient, such as how some require combination therapy which employs surgical and systemic therapy to combat their disease, or others need surgery.</p>
            <p>Dr Arakelyan then outlined the advantages of systemic therapy, such as how it can kill microscopic diseases and formulate tailored treatment plans, such as hormone therapy, or a patient can be analysed for mutations, and treatment can be curated specifically for that. However, the major pitfall of these treatments is toxicity. Dr Arakelyan explained how common chemotherapeutic agents have high toxicity and ultimately affect patients' quality of life. She expressed how patients with this disease often care more about their quality of life rather than their length of it, which further stresses the need to develop a treatment with reduced toxicity side effects.</p>
            <p>We then asked whether she believes this miracle cure for cancer can be found in newly developed drugs or whether more time and research should be invested in current medications on the market. Dr Arakelyan then described oncology as a field where the &lsquo;one size fits all&rsquo; approach cannot be applied, and that there are many effective drugs made from natural products that are already available and by finetuning them to lower specific side effects paves the way for personalised medicine which, in her opinion, is the most viable approach to battling this disease.</p>
            <p>We introduced the iGEM competition to Dr Arakelyan and explained how we performed fungal transformation to produce these natural products that exhibit anticancer and antimicrobial properties. We then discussed our plans to perform <em>in vitro</em> tests on cancer cell lines to verify their toxicity. From there, we asked whether Dr Arakelyan, as an oncologist, sees herself using our drug in the future. <u>We received positive feedback on our project execution and ultimately received approval for our approach from an experienced doctor in the field.</u></p>
            <p><strong>The interview helped us understand more about the oncology field and the experience of patients who go through this disease which further motivated us to enhance and refine our work.</strong> Dr Arakelyan indulged us in the treatments that often sought to tackle cancer and what aspects affect patients' lives. <strong>We implemented her advice and performed some modelling for our project, and focused our research on toxicity and studying the extent to which we could minimise this.</strong> We thank Dr Arakelyan for her time and advice for our project and appreciate the interview experience.</p>

            <p>
              <iframe title="CityU_HongKong: Interview with the Oncologist Dr Jemma Arakelyan (2022) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/a899bf82-23cd-47e5-9b26-493fff778a96" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
            </p>
          </section>

        </div>
      </section>
    </div>
  );
}

export default ExpertInterviews;
